import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { State } from '../../services/global-state';

@inject(Router, State)
export class Logout {
	router: Router;
	globalState: State;

	constructor(router: Router, state: State) {
		this.router = router;
		this.globalState = state;
	}

	activate() {
		this.globalState.logout();
		if (this.globalState.business.portalSettings.ezpay.ezpayOnly) {
			this.router.navigateToRoute('ezpay');
		} else {
			this.router.navigateToRoute('login');
		}
	}
}
